
const totalAnimationDurationMs = 2500;

document.addEventListener('DOMContentLoaded', () => {
  const counterElements = Array.from(document.getElementsByClassName('counting-up-numbers-item__figure'));

  counterElements.forEach((root) => {
    const targetString = root.getAttribute('data-counter-target');

    const target = parseFloat(targetString);
    const prefix = root.getAttribute('data-counter-prefix') || '';
    const suffix = root.getAttribute('data-counter-suffix') || '';
    let precision = 0;
    if (/\./.test(targetString)) {
      precision = targetString.replace(/^.*?\./, '').length;
    }

    function generateText(animationProgress) {
      const currentValue = target * animationProgress;
      const currentValueFixed = currentValue.toFixed(precision);
      const formattedValue = currentValueFixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${prefix}${formattedValue}${suffix}`;
    }

    try {
      const observer = new IntersectionObserver((ev) => {
        if (!ev[0].isIntersecting) {
          return;
        }

        observer.disconnect();

        const animationStartTime = Date.now();
        function animateNumbersFrame() {
          const durationProgress = (Date.now() - animationStartTime) / totalAnimationDurationMs;
          const lastFrame = durationProgress >= 1;

          // problem with compilation - using Math - ** operator results in compilation error
          /* eslint-disable-next-line no-restricted-properties */
          const animationProgress = lastFrame ? 1 : Math.pow(durationProgress, 1 / 3);

          /* eslint-disable-next-line no-param-reassign */
          root.innerHTML = generateText(animationProgress);

          if (!lastFrame) {
            setTimeout(animateNumbersFrame, 10 + 90 * durationProgress);
          }
        }
        animateNumbersFrame();
      });
      observer.observe(root);

      /* eslint-disable-next-line no-param-reassign */
      root.innerHTML = '';
    } catch (err) {
      // fall-back for browsers not supporting IntersectionObserver (IE)
      /* eslint-disable-next-line no-param-reassign */
      root.innerHTML = generateText(1);
    }
  });
});
